import React, { PropsWithChildren } from "react";

import { Glycemia } from "@/models/diabetes/GlycemiaModel.ts";
import { SvgDataTooltip, SvgDataTooltipFooter, SvgDataTooltipTitle } from "@/uiKit/atoms/svg/SvgDataTooltip.tsx";
import { Tooltip } from "@/uiKit/atoms/Tooltip.tsx";
import { formatNumber } from "@/utils/mathUtils.ts";

export type GlycemiaGraphTooltipProps = PropsWithChildren<{
  glycemia: Glycemia;
}>;

const GlycemiaTooltipContent: React.FC<{
  glycemia: Glycemia;
}> = ({ glycemia }) => {
  return (
    <SvgDataTooltip>
      <SvgDataTooltipTitle
        title={glycemia.outOfRange ? glycemia.outOfRange.toUpperCase() : `${formatNumber(glycemia.value, 0)} mg/dL`}
      />
      <SvgDataTooltipFooter date={glycemia.date} inputMethod={glycemia.deviceType} />
    </SvgDataTooltip>
  );
};

export const GlycemiaGraphTooltip: React.FC<GlycemiaGraphTooltipProps> = ({ glycemia, children }) => {
  return (
    <Tooltip
      popupId="glycemia-graph-tooltip"
      svg
      placement="top"
      dismiss={false}
      autoOpen
      offset={0}
      content={<GlycemiaTooltipContent glycemia={glycemia} />}
    >
      {children}
    </Tooltip>
  );
};

export type GlycemiaPointTooltipProps = PropsWithChildren<{
  glycemia: Glycemia;
  x?: number;
  y?: number;
}>;

export const GlycemiaPointTooltip: React.FC<GlycemiaPointTooltipProps> = ({ glycemia, x, y, children }) => {
  return (
    <Tooltip
      popupId="glycemia-point-tooltip"
      svg
      placement="top"
      relativeClientPoint
      clientPoint={{
        enabled: true,
        x: x ?? 0,
        y: y ?? 0,
      }}
      content={<GlycemiaTooltipContent glycemia={glycemia} />}
    >
      {children}
    </Tooltip>
  );
};
